import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { formatDisplayDateTime } from '../../lib/dateDisplay';
import { connect } from 'react-redux';
import { useDispatch } from 'react-redux';
import { ProductAction, AlertAction, AuthAction } from '../../actions';
import { ProgramConstant } from '../../actions/constants/ProgramConstant';
import { RayForm, RayFormValidation } from '../common';
import { DeviceModels } from '../../config/RayCodes';
import { Translate as t } from '../../config/Translate';

const ProductErrorInfo = ({ errorCodeInfo, sn, productErrorCodeId, nocard = false }) => {
	const isAdmin = location.pathname.toLowerCase().startsWith('/admin/');
	const [contols, setControls] = useState([]);
	const dispatch = useDispatch();

	const callbackclick = (v) => {
		dispatch({ type: ProgramConstant.ERRORCODELOOKUP_SHOW, eCode: v })
	}
	const showKey = [
		{ label: t('product.field.errorCode'), value: "code", link: isAdmin ? "/Admin/AdminErrorCodeInfo/" : "ERRORCODELOOKUP", callbackclick: callbackclick },
		{ label: t('common.button.begin'), value: "begin", type: "DT" },
		{ label: t('common.label.end'), value: "end", type: "DT" },
		{ label: t('common.field.durationTime'), value: "duration" },
		{ label: t('service.field.closer'), value: "closer" },
		{ label: t('service.label.customerFeedback'), value: "commentForCustomer" },
		{ label: t('common.field.description'), value: "description" },
		{ label: t('common.status.registered'), value: "timestamp", type: "DT" }
	]

	const getProductError = async () => {
		errorCodeInfo = await ProductAction.GetProductErrorId(sn, productErrorCodeId);
		setUpControl();
	}

	const getVal = (x) => {
		if (x.value == "duration") {
			return moment.duration(parseInt(errorCodeInfo[x.value]), 'seconds').humanize();
		} else if (x.type == "DT") {
			const rList = [];
			rList.push(moment.utc(errorCodeInfo[x.value]).local().fromNow());
			rList.push(<span className="text-muted small">({formatDisplayDateTime(errorCodeInfo[x.value], { seconds: false })})</span>);
			return rList;
		} else {
			return errorCodeInfo[x.value];
		}
	}

	const setUpControl = () => {
		const objs = [];
		showKey.map(x => {
			if (errorCodeInfo[x.value]) {
				const obj = {
					title: '', items: [{
						type: 'input',
						name: x.value,
						label: x.label,
						viewLinkPath: x.link,
						callbackclick: x.callbackclick,
						val: getVal(x),
						size: 12
					}]
				};
				objs.push(obj);
			}
		});
		//objs[0].title = "Error Information";

		setControls(objs);
	}

	useEffect(() => {
		if (errorCodeInfo) {
			setUpControl();
		} else if (productErrorCodeId) {
			getProductError();
		}
	}, []);

	return <RayForm controls={contols} nocard={nocard} />;
};

export default ProductErrorInfo;